import script from "./sw-item-viewer.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-viewer.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-viewer.vue?vue&type=style&index=0&id=4b2d15b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b2d15b8"]])

export default __exports__